export default __webpack_public_path__ + "static/media/09_grandmaster.d5044f99.svg";